import { API_AUTH_MODAL_URL } from "src/constants/urls";
import { useQuery } from "src/lib/tanstack-query/hooks/use-query";
import { IAuthModalResponse } from "./auth-modal.api.types";

export function useAuthModalQuery(isAuthModalOpen: boolean) {
    return useQuery<IAuthModalResponse>({
        url: API_AUTH_MODAL_URL,
        enabled: isAuthModalOpen,
        // Dev-Note: once the auth modal is opened, we don't want to refetch it again and therefore store it in the cache forever
        gcTime: Infinity,
        staleTime: Infinity,
    });
}
